export default "__VITE_ASSET__4f84bab7__"